<template>
    <modal @close="closeFromModal">
        <h5 slot="header">
            {{ productComponent.id === null ? $tl("labels.form.actions.add") : $tl("labels.form.actions.edit") }}
            {{ $tl("labels.clickAndCollect.modals.titles.formulaComponent") }}
        </h5>
        <div slot="body">
            <add-click-and-collect-add-formule-component
                ref="addClickAndCollectAddFormuleComponent"
                @saved="$emit('saved')"
                :productComponent="productComponent" />
        </div>
        <div slot="footer" class="d-flex">
            <button type="button" class="modal-default-button btn btn-sm btn-secondary btn-circle" @click="$emit('close')">
                {{ $tl("labels.form.actions.cancel") }}
            </button>
            <button type="button" class="btn btn-sm btn-success btn-circle ms-2" @click="$refs.addClickAndCollectAddFormuleComponent.save()">
                {{ $tl("labels.form.actions.validate") }}
            </button>
        </div>
    </modal>
</template>

<script>
import addClickAndCollectAddFormuleComponent from "../../clickAndCollect/addClickAndCollectAddFormuleComponent";

export default {
    props: {
        productComponent: {
            type: Object,
            required: true,
        },
    },
    methods: {
        close() {
            this.$emit("close");
        },
        closeFromModal: function (e) {
            e.stopPropagation();
            if (e && e.target && !e.target.classList.contains("modal-wrapper")) {
                e.stopPropagation();
            } else {
                this.close();
            }
        },
    },
    components: {
        addClickAndCollectAddFormuleComponent,
    },
};
</script>
